<!--
/**
* @description: 悬浮框
* @author: yangbo@yuouhui1.com
* @date: 2021-04-19 13:37:58
*/
-->
<template>
  <div :class="css.box">
    {{ value }}
    <k-icon :color="color" :size="size" :class="css.icon" :name="icon"></k-icon>
    <div
      :class="direction === 'left' ? css.left + ' ' + css.box1 : direction === 'right' ? css.right + ' ' + css.box1 : direction === 'bottom' ? css.bottom + ' ' + css.box1 : css.top + ' ' + css.box1"
      :style="{ width: width + 'px' }"
    >
      <div :class="css.content">
        <div :class="css.title" v-if="title">{{ title }}</div>
        <div :class="css.tip" :style="{ padding: title ? '0 8px 8px 8px' : '10px' }">{{ tipValue }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "tootip",
  props: {
    value: {
      type: String,
      default: "",
    },
    tipValue: {
      type: String || Function,
      default: "",
      required: true,
    },
    width: {
      type: Number,
      default: 200,
    },
    direction: {
      type: String,
      default: "right",
    },
    title: {
      type: String,
    },
    color: {
      type: String,
      default: "#3487ff",
    },
    icon: {
      type: String,
      default: "k-icon-question",
    },
    size: {
      type: String,
      default: "18px",
    },
  },
  data() {
    return {
      tipValue: this.tipValue,
    };
  },
  created() {
    if (typeof this.tipValue === "string") {
      this.tipValue = this.tipValue;
    } else if (typeof this.tipValue === "function") {
      this.tipValue = this.tipValue();
    }
  },
  methods: {},
};
</script>
<style lang="postcss" scoped module="css">
.box {
  position: relative;
  display: inline-flex;
  align-items: center;
  /* z-index: 1; */
  & .box1 {
    display: none;
    width: 200px;
    border-radius: 10px;
    background: #fff;
    border: 1px solid #ddd;
    text-align: justify;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
    & .title {
      width: 100%;
      height: 25px;
      line-height: 25px;
      border-bottom: 1px solid #eee;
      font-size: 12px;
      margin-bottom: 5px;
      padding: 0 8px;
    }
    & .tip {
      padding: 10px 10px 10px 10px;
    }
  }
  & .icon {
    margin-left: 3px;
  }
  & .top {
    position: absolute;
    left: 50%;
    top: -10px;
    transform: translate(-50%, -100%);
    & .content {
      position: relative;
      &::before {
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: -10px;
        border-left: 5px solid transparent;
        border-top: 10px solid #fff;
        border-right: 5px solid transparent;
        z-index: 99999;
        content: "";
      }
      &::after {
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: -10px;
        border-left: 7px solid transparent;
        border-top: 10px solid #ddd;
        border-right: 7px solid transparent;
        content: "";
      }
    }
  }
  & .bottom {
    position: absolute;
    left: 50%;
    bottom: -12px;
    transform: translate(-50%, 100%);
    & .content {
      position: relative;
      &::before {
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        top: -10px;
        border-left: 5px solid transparent;
        border-bottom: 10px solid #fff;
        border-right: 5px solid transparent;
        z-index: 99999;
        content: "";
      }
      &::after {
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        top: -10px;
        border-left: 7px solid transparent;
        border-bottom: 10px solid #ddd;
        border-right: 7px solid transparent;
        content: "";
      }
    }
  }
  & .left {
    position: absolute;
    left: -20px;
    top: 0;
    transform: translate(-100%, 0);
    & .content {
      position: relative;
      &::before {
        position: absolute;
        top: 6px;
        /* transform: translate(0, -50%); */
        right: -10px;
        border-top: 5px solid transparent;
        border-left: 10px solid #fff;
        border-bottom: 5px solid transparent;
        z-index: 99999;
        content: "";
      }
      &::after {
        position: absolute;
        top: 4px;
        /* transform: translate(0, -50%); */
        right: -10px;
        border-top: 7px solid transparent;
        border-left: 10px solid #ddd;
        border-bottom: 7px solid transparent;
        content: "";
      }
    }
  }
  & .right {
    position: absolute;
    right: -20px;
    top: 50%;
    transform: translate(100%, -50%);
    & .content {
      position: relative;
      &::before {
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        left: -10px;
        border-top: 5px solid transparent;
        border-right: 10px solid #fff;
        border-bottom: 5px solid transparent;
        z-index: 99999;
        content: "";
      }
      &::after {
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        left: -10px;
        border-top: 7px solid transparent;
        border-right: 10px solid #ddd;
        border-bottom: 7px solid transparent;
        content: "";
      }
    }
  }
}
.box:hover {
  &::before {
    display: block;
  }
  & .box1 {
    display: block;
    z-index: 1;
  }
}
</style>
